import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Home extends Component {
    render() {
        return (
            <div className="min-h-screen bg-[#f8fafc] text-[#0f172a]">

                {/* HERO */}
                <section className="bg-white border-b border-[#e2e8f0]">
                    <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
                        <div className="grid lg:grid-cols-2 gap-14 items-center">

                            {/* LEFT */}
                            <div>
                                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#e2e8f0] bg-[#f8fafc] text-[13px] text-[#475569] font-medium mb-6">
                                    <span className="w-2 h-2 rounded-full bg-emerald-500" />
                                    Automation on demand
                                </div>

                                <h1 className="text-4xl md:text-6xl font-bold leading-[1.05] tracking-tight">
                                    Don't pay for automation while it waits.
                                </h1>

                                <p className="mt-5 text-lg text-[#64748b] max-w-xl leading-relaxed">
                                    Get ready-to-use business automation systems,
                                    deploy them when you need them, and pay for
                                    the infrastructure that actually does the work.
                                </p>

                                <div className="flex flex-wrap gap-3 mt-8">
                                    <Link
                                        to="/cp/deployments"
                                        className="hk-btn hk-btn-primary px-6 py-3 text-[15px]"
                                    >
                                        Browse free systems
                                    </Link>
                                    <a
                                        href="#free"
                                        className="hk-btn px-6 py-3 text-[15px]"
                                    >
                                        See what's free
                                    </a>
                                </div>

                                <div className="mt-8 flex flex-wrap gap-x-8 gap-y-2 text-sm text-[#64748b]">
                                    <div><span className="font-semibold text-[#0f172a]">Free</span> automation systems</div>
                                    <div><span className="font-semibold text-[#0f172a]">Free</span> deployment credit</div>
                                    <div><span className="font-semibold text-[#0f172a]">Pay-as-you-run</span></div>
                                </div>
                            </div>

                            {/* RIGHT — run card */}
                            <div>
                                <div className="rounded-2xl border border-[#e2e8f0] bg-white shadow-sm p-6">
                                    <div className="flex items-center justify-between mb-5">
                                        <div className="flex gap-2">
                                            <div className="w-3 h-3 bg-[#e2e8f0] rounded-full" />
                                            <div className="w-3 h-3 bg-[#e2e8f0] rounded-full" />
                                            <div className="w-3 h-3 bg-emerald-400 rounded-full" />
                                        </div>
                                        <div className="text-[11px] font-semibold text-[#64748b] tracking-wide">
                                            HAKI EXECUTION
                                        </div>
                                    </div>

                                    <div className="space-y-3">
                                        <div className="p-4 rounded-xl bg-[#f8fafc] border border-[#f1f5f9]">
                                            <div className="text-[11px] text-[#64748b] font-semibold mb-1">SYSTEM</div>
                                            <div className="font-semibold">B2B Lead Generation</div>
                                        </div>

                                        <RunStep n="01" title="Deploy when needed" text="Infrastructure starts only for the job" />
                                        <RunStep n="02" title="Run automation" text="Find, enrich and qualify leads" />
                                        <RunStep n="03" title="Finish and shut down" text="No idle infrastructure waiting for the next run" />

                                        <div className="border-t border-[#e2e8f0] pt-4 mt-2">
                                            <div className="flex justify-between items-center text-sm">
                                                <span className="text-[#64748b] hk-mono text-xs">cost $0.42 · 11 min</span>
                                                <span className="hk-pill hk-pill-green">✓ Completed</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* FREE VALUE */}
                <section id="free" className="py-20 px-6">
                    <div className="max-w-6xl mx-auto">
                        <div className="mb-10">
                            <div className="hk-eyebrow">Free to start</div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-3">
                                Get the automation. Not the agency bill.
                            </h2>
                            <p className="text-[#64748b] max-w-3xl">
                                Use ready-to-deploy systems instead of paying
                                thousands to have basic automation built from scratch.
                                Explore them for free and try a real deployment with
                                free deployment credit.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-4">
                            <FreeCard
                                icon="🎯"
                                title="B2B Lead Generation"
                                text="Find businesses matching your target market, enrich prospects and deliver qualified leads to your workflow."
                                cta="Generate Leads"
                            />
                            <FreeCard
                                icon="🌐"
                                title="Business Website"
                                text="Generate a professional website for your business without starting from an empty page."
                                cta="Build A Website"
                            />
                            <FreeCard
                                icon="🔍"
                                title="Automation Audit"
                                text="Already have an automation? Send it to us for a manual review of its architecture, reliability, cost and opportunities for improvement."
                                cta="Get Free Audit"
                            />
                        </div>
                    </div>
                </section>

                {/* VALUE PROPOSITION */}
                <section className="py-20 px-6 bg-white border-y border-[#e2e8f0]">
                    <div className="max-w-6xl mx-auto">
                        <div className="hk-eyebrow">Why Haki</div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-3">
                            Your automation doesn't need to run 24/7.
                        </h2>
                        <p className="text-[#64748b] max-w-3xl mb-10">
                            A daily lead scraper, weekly report, content generator
                            or data processor doesn't need a server sitting there
                            all day waiting for its next job.
                        </p>

                        <div className="grid lg:grid-cols-2 gap-4">
                            <div className="hk-card">
                                <h3 className="font-semibold text-lg mb-4">Always-on automation</h3>
                                <div className="space-y-3 text-[#64748b] text-[15px]">
                                    <div>❌ Infrastructure sits idle</div>
                                    <div>❌ Pay while your automation waits</div>
                                    <div>❌ Maintain another always-running service</div>
                                    <div>❌ Turn every workflow into a hosting problem</div>
                                </div>
                            </div>
                            <div className="hk-card hk-card-dark">
                                <h3 className="font-semibold text-lg mb-4">Haki on-demand</h3>
                                <div className="space-y-3 text-[#cbd5e1] text-[15px]">
                                    <div>✅ Keep your automation ready</div>
                                    <div>✅ Deploy when it needs to work</div>
                                    <div>✅ Run the job</div>
                                    <div>✅ Shut down when the work is finished</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* HOW IT WORKS */}
                <section className="py-20 px-6">
                    <div className="max-w-6xl mx-auto">
                        <div className="hk-eyebrow">Process</div>
                        <h2 className="text-3xl font-bold mb-2">From problem to running system</h2>
                        <p className="text-[#64748b] mb-10">
                            Start with a system. Add your business data. Let Haki handle the deployment.
                        </p>
                        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            <Step number="01" title="Choose" text="Pick a ready-to-use automation for the job you need done." />
                            <Step number="02" title="Configure" text="Connect your accounts, credentials and business data." />
                            <Step number="03" title="Deploy" text="Haki provisions the infrastructure and starts your system." />
                            <Step number="04" title="Run" text="Let the automation work, then shut it down when finished." />
                        </div>
                    </div>
                </section>

                {/* SYSTEMS */}
                <section id="systems" className="py-20 px-6 bg-white border-y border-[#e2e8f0]">
                    <div className="max-w-7xl mx-auto">
                        <div className="mb-10">
                            <div className="hk-eyebrow">Catalog</div>
                            <h2 className="text-3xl md:text-4xl font-bold mb-3">Free automation systems</h2>
                            <p className="text-[#64748b] max-w-2xl">
                                Start with a proven system instead of paying
                                thousands of dollars to build one from scratch.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <SystemCard icon="🎯" title="B2B Lead Generation" description="Find, enrich and qualify businesses matching your ideal customer." status="Free system" />
                            <SystemCard icon="🤖" title="AI Support Agent" description="Answer customer questions, handle common requests and escalate when necessary." status="Free system" />
                            <SystemCard icon="📅" title="Appointment Automation" description="Capture inquiries, qualify prospects and move them toward booking." status="Free system" />
                            <SystemCard icon="📣" title="Lead Follow-Up" description="Automatically follow up with prospects until they reply, book or opt out." status="Free system" />
                            <SystemCard icon="📝" title="Content Automation" description="Research, generate and prepare content through repeatable workflows." status="Free system" />
                            <SystemCard icon="🔧" title="Custom Automation" description="Bring an existing workflow or business process and turn it into a deployable system." status="Talk to us" />
                        </div>
                    </div>
                </section>

                {/* AUDIT */}
                <section className="py-20 px-6">
                    <div className="max-w-5xl mx-auto">
                        <div className="hk-card-dark hk-card !p-8 md:!p-10">
                            <div className="grid md:grid-cols-2 gap-8 items-center">
                                <div>
                                    <div className="hk-eyebrow" style={{ color: "#94a3b8" }}>Free manual audit</div>
                                    <h2 className="text-3xl font-bold mb-4">Already have an automation?</h2>
                                    <p className="text-[#cbd5e1]">
                                        Send us your existing workflow. We'll manually
                                        review it and identify opportunities to improve
                                        its architecture, reliability, execution cost
                                        and overall result.
                                    </p>
                                </div>
                                <div className="space-y-2">
                                    <AuditPoint text="Find unnecessary or duplicated steps" />
                                    <AuditPoint text="Identify fragile points and failure risks" />
                                    <AuditPoint text="Look for expensive or inefficient operations" />
                                    <AuditPoint text="Recommend practical improvements" />
                                    <button className="w-full mt-2 px-4 py-2.5 rounded-lg bg-white text-[#0f172a] text-sm font-semibold hover:bg-[#f1f5f9] transition">
                                        Submit my automation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FREE DEPLOYMENT */}
                <section className="px-6 pb-20">
                    <div className="max-w-5xl mx-auto text-center hk-card !py-14">
                        <div className="hk-eyebrow" style={{ textAlign: "center" }}>Try a real deployment</div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-4">Your first deployment is on us.</h2>
                        <p className="text-[#64748b] max-w-2xl mx-auto mb-8">
                            Create an account and receive free Haki deployment credit.
                            Use it to deploy a system with your own data and see what
                            the automation can actually do.
                        </p>
                        <Link to="/cp/deployments" className="hk-btn hk-btn-primary px-8 py-3">
                            Start your free deployment
                        </Link>
                        <div className="mt-4 text-[13px] text-[#64748b]">
                            No long-term commitment. Pay only when you need additional usage.
                        </div>
                    </div>
                </section>

                {/* FAQ */}
                <section className="py-20 px-6 bg-white border-t border-[#e2e8f0]">
                    <div className="max-w-4xl mx-auto">
                        <div className="hk-eyebrow">Questions</div>
                        <h2 className="text-3xl font-bold mb-10">Frequently asked questions</h2>
                        <div className="space-y-3">
                            <FaqItem q="Are the automation systems really free?" a="Yes. The systems themselves are free to use as the starting point for your automation. Running them uses deployment resources, which are charged through Haki." />
                            <FaqItem q="What do I get when I sign up?" a="You get access to free automation systems and free Haki deployment credit that you can use to try a real deployment." />
                            <FaqItem q="Why would I use Haki instead of keeping my automation running all the time?" a="Not every automation needs to run continuously. Haki lets you deploy systems when they need to work and shut them down when the work is finished." />
                            <FaqItem q="Is Haki just another n8n hosting service?" a="Haki is designed around the automation itself rather than simply keeping an automation server online. Systems can be deployed when needed, run, and shut down when their work is complete." />
                            <FaqItem q="Do I need technical skills?" a="The goal is to remove the infrastructure work. You may still need to connect accounts, APIs or business data depending on the system you choose." />
                            <FaqItem q="Can I use my own automation?" a="Yes. You can bring an existing automation for review, and we can identify ways to improve its architecture, reliability, efficiency or cost." />
                            <FaqItem q="What happens when my automation is not running?" a="For on-demand systems, the deployment can be stopped after execution instead of remaining active while waiting for the next run. Scheduled systems can provision the required environment when it is time to work." />
                        </div>
                    </div>
                </section>

                {/* FINAL CTA */}
                <section className="hk-stage">
                    <div className="max-w-4xl mx-auto text-center px-6 py-20">
                        <h2 className="text-3xl md:text-5xl font-bold leading-tight">
                            Get the automation.<br />Deploy it when you need it.
                        </h2>
                        <p className="text-[#cbd5e1] text-lg mt-5 mb-8 max-w-2xl mx-auto">
                            Start with a free automation system and free deployment credit.
                            Pay for additional execution only when you actually need it.
                        </p>
                        <Link to="/cp/deployments" className="inline-flex items-center px-8 py-3 rounded-lg bg-white text-[#0f172a] text-[15px] font-semibold hover:bg-[#f1f5f9] transition">
                            Browse free systems
                        </Link>
                    </div>
                </section>

            </div>
        );
    }
}


/* COMPONENTS */

class RunStep extends Component {
    render() {
        return (
            <div className="flex items-center gap-3 text-sm">
                <div className="w-8 h-8 rounded-lg bg-[#f1f5f9] text-[#0f172a] font-semibold flex items-center justify-center text-xs shrink-0">
                    {this.props.n}
                </div>
                <div>
                    <div className="font-medium">{this.props.title}</div>
                    <div className="text-[#64748b] text-[13px]">{this.props.text}</div>
                </div>
            </div>
        );
    }
}


class Step extends Component {
    render() {
        return (
            <div className="hk-card hk-ticket">
                <div className="hk-mono text-xs font-bold text-[#64748b] mb-2">/{this.props.number}</div>
                <h3 className="font-semibold text-lg mb-1">{this.props.title}</h3>
                <p className="text-[#64748b] text-sm leading-relaxed">{this.props.text}</p>
            </div>
        );
    }
}


class SystemCard extends Component {
    render() {
        return (
            <div className="hk-card">
                <div className="flex justify-between items-start mb-4">
                    <div className="text-3xl">{this.props.icon}</div>
                    <span className="hk-pill hk-pill-zinc">{this.props.status}</span>
                </div>
                <h3 className="text-lg font-semibold mb-1">{this.props.title}</h3>
                <p className="text-[#64748b] text-sm">{this.props.description}</p>
            </div>
        );
    }
}


class FreeCard extends Component {
    render() {
        return (
            <div className="hk-card">
                <div className="text-4xl mb-4">{this.props.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{this.props.title}</h3>
                <p className="text-[#64748b] text-[15px] leading-relaxed">{this.props.text}</p>
                <div className="mt-5">
                    <button className="text-[#0f172a] text-sm font-semibold hover:underline">
                        {this.props.cta} →
                    </button>
                </div>
            </div>
        );
    }
}


class AuditPoint extends Component {
    render() {
        return (
            <div className="flex items-start gap-3 p-3 rounded-lg bg-[#1e293b]">
                <div className="w-6 h-6 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center text-xs font-bold flex-shrink-0">
                    ✓
                </div>
                <span className="text-[#e2e8f0] text-sm">{this.props.text}</span>
            </div>
        );
    }
}


class FaqItem extends Component {
    state = { open: false };

    toggle = () => {
        this.setState({
            open: !this.state.open
        });
    };

    render() {
        return (
            <div className="hk-card !p-0 overflow-hidden">
                <button
                    onClick={this.toggle}
                    className="w-full text-left flex justify-between items-center gap-4 p-5"
                >
                    <span className="font-semibold">{this.props.q}</span>
                    <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition ${this.state.open ? "bg-[#0f172a] text-white" : "bg-[#f1f5f9] text-[#64748b]"}`}>
                        {this.state.open ? "−" : "+"}
                    </span>
                </button>
                {this.state.open && (
                    <p className="px-5 pb-5 text-[#64748b] text-sm leading-relaxed">
                        {this.props.a}
                    </p>
                )}
            </div>
        );
    }
}


export default Home;
